<template>
    <div class="flask">
        <div class="top"></div>
        <div class="base">
            <div class="triangle-left"></div>
            <div class="triangle-right"></div>
            <div class="inner">
                <div class="fill">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="300px"
                        height="300px"
                        viewBox="0 0 300 300"
                        enable-background="new 0 0 300 300"
                        xml:space="preserve"
                    >
                        <path
                            class="waveShape"
                            d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                    c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                    c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.flask {
    height: 120px;
    width: 120px;
}

.flask .top {
    position: relative;
    border-left: 1px solid black;
    border-right: 1px solid black;
    height: 39px;
    width: 28px;
    margin: 0 46px;
    margin-bottom: 1px;
    box-shadow:
        inset 0 0 0 0 rgba(0, 0, 0, 0.05),
        inset 0 -15px 5px 0 rgba(0, 0, 0, 0.05),
        inset -15px 0 5px 0 rgba(0, 0, 0, 0.05),
        inset 15px 0 5px 0 rgba(0, 0, 0, 0.05);
}
.flask .base {
    position: relative;
    width: 120px;
    height: 80px;
}

.flask .base:after {
    border-bottom: 1px solid black;
    content: "";
    position: absolute;
    width: 120px;
    bottom: 0;
    left: 0;
    box-shadow: 0 -2.5px 5px 1px rgba(0, 0, 0, 0.5);
}

.triangle-right {
    position: absolute;
    margin: auto;
    top: 17px;
    left: 63px;
    width: 93px;
    height: 30px;
    transform: rotate(60deg);
    border-bottom: 1px solid black;
    background-color: #f8fafc;
    z-index: 2;
    box-shadow: -0px 15px 11px -13px rgba(0, 0, 0, 1);
}

.triangle-left {
    position: absolute;
    margin: auto;
    top: 17px;
    left: -36px;
    width: 93px;
    height: 30px;
    transform: rotate(-60deg);
    border-bottom: 1px solid black;
    background-color: #f8fafc;
    z-index: 2;
    box-shadow: -0px 15px 11px -13px rgba(0, 0, 0, 1);
}

.flask .base:before {
    overflow: hidden;
    border-radius: 0 0 25px 25px;
    content: "";
    position: absolute;
    width: 120px;
    height: 80px;
    z-index: 2;
}
.flask .top::after {
    overflow: hidden;
    border-radius: 0 0 25px 25px;
    content: "";
    background: black;
    position: absolute;
    width: 38px;
    height: 5px;
    z-index: 2;
    top: 0;
    left: -6px;
}

.flask .base .inner {
    width: 120px;
    height: 80px;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
}
.flask .base .inner:before {
    content: "";
    width: 10px;
    height: 10px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    position: absolute;
    right: 70%;
    top: 70%;
    z-index: 2;
}
.flask .base .inner:after {
    content: "";
    width: 10px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    position: absolute;
    right: 35%;
    top: 45%;
    transform: rotate(-20deg);
    z-index: 2;
}

.fill {
    animation-name: fillAction;
    animation-iteration-count: 1;
    animation-timing-function: cubic-bezier(0.4, 0.2, 0.8, 0.4);
    animation-duration: 1s;
    animation-fill-mode: forwards;
}
.waveShape {
    animation-name: waveAction;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 0.5s;
    width: 300px;
    height: 150px;
    fill: #ee7200;
}

@keyframes fillAction {
    0% {
        transform: translate(0, 80px);
    }
    100% {
        transform: translate(0, 25px);
    }
}
@keyframes waveAction {
    0% {
        transform: translate(-150px, 0);
    }
    100% {
        transform: translate(0, 0);
    }
}
</style>

<script>
export default {
    name: "FlaskIcon",
};
</script>
